import script from "./CreateProjectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateProjectModal.vue?vue&type=script&setup=true&lang=ts"

import "./CreateProjectModal.vue?vue&type=style&index=0&id=17d3c9ff&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17d3c9ff"]])

export default __exports__